<script lang="ts" setup>
import {
  onMounted,
  reactive,
  useTemplateRef,
  ref,
  nextTick,
  getCurrentInstance,
  watch,
} from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  loadStichtagfromConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";

import AUApi from "@/api";
import { Globals } from "@/Globals";
import {
  globalsBezeichnung,
  globalsStt,
  globalsAic,
  globalsBegriffCache,
  checkBegriff,
  globalsBegriffMemo,
} from "@/local";
import Constants from "@/Constants";
import { Capacitor } from "@capacitor/core";
import { scanBarcode, BarcodeScanResult } from "@/BarcodeScanWrapper";
import { getDisplay } from "@/DataHelper";
import { showSnackbar, showDialog } from "@/UIHelper";
import { Keyboard } from "@capacitor/keyboard";
import { onShowSite } from "@/NavigationHelper";
import EditComboBoxItem from "@/editor/EditComboBoxItem.vue";
import { ref as vueRef, nextTick as vueNextTick } from "vue";
// Overlay-Breite für die Combobox
const overlayWidth = vueRef(0);

function updateOverlayWidth() {
  vueNextTick(() => {
    // Suche das Overlay-Element (Vuetify 4: v-overlay__content)
    const overlays = document.querySelectorAll(".v-overlay__content");
    let maxWidth = 800;
    overlays.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.width < maxWidth) {
        maxWidth = rect.width;
      }
    });

    overlayWidth.value = maxWidth;
  });
}
import {
  EditComboboxControlProps,
  EditComboboxItemData,
  EditComboBoxItemUiData,
  EditComboBoxUiData,
  iconNoFav,
} from "./EditComboboxFunctions";
import { useRegisterValidation } from "@/components/EditorValidator";
const emitFn = defineEmits<CommonEditControlEmits>();

// eigene props deklarieren können
// eigene config machen
declare interface EditComboboxControlConfig extends EditorControlConfig {
  zeitbereich?: APIZeitbereich;
}

const props = defineProps<EditComboboxControlProps>();
const { config, ui } = getDefaultEditorControlConfig<
  EditComboboxControlConfig,
  EditComboboxControlProps,
  EditComboBoxUiData
>(props, emitFn);
config.validate = validate;
useRegisterValidation({ config });

const uiData = reactive(ui);

let barcodeButtonVisible = ref<boolean>(false);
let austritte: string = "0";
let rawlist: EditComboboxItemData[] = [];

let cacheItems = ref<boolean>(false);
let aicMode: boolean = true;
let field: any = config.querycolumn;

let sysAbfrage: any = null;

let menuwith: string = "min-content";
let autofill: boolean = true; // die Combobox wird automatisch gefüllt bei TRUE
let favColumn: any = null; // column für Favoriten wenn vorhanden...
let barcodeColumn: any = null;
let initialized: boolean = false;
const combobox = ref<any>(null);
let favorite: boolean = false;
let kennungFavoritCol: string = "FAVORIT";
let kennungBarcodeCol: string = "Barcode";
let fields: any = { text: "description", value: "aic" };
let showSelect: boolean = false;
let useAutocomplete: boolean = false;
let anzahlCols = ref<number>(12);
let setCompKey = ref<number>(0);
let searchActive = ref<boolean>(false);
// moved refresh out of mounted to call it from extern :P
async function refreshData(cacheQuery: boolean = true) {
  if (props.query && !props.kennung) {
    // wird ein Query übergeben, dann muss ich die Daten für die
    // ComboBox erst laden! dann ist die Combo NICHT Teil einer Abfrage
    uiData.showLoading = true;
    const vecStamm: any[] = [];
    return AUApi.Current.getQuery(
      props.query,
      (data: any) => dataLoadedFromServer(data),
      0, // Stammsatz für die ABfrage muss in diesem fall LEER Sein
      config.zeitbereich, // Zeitbereich muss auch übergeben werden...
      0,
      cacheQuery, // cachen ein ausschalten nach Definition
      false,
      "1",
      0,
      vecStamm,
      "",
      false,
      0,
      [],
      [],
      austritte,
    );
  }
  return Promise.resolve();
}
const inputRef = useTemplateRef("combobox");
onMounted(async () => {
  // if (props.autofocus && inputRef.value)  {
  //   inputRef.value.focus();
  // }
  if (!config.initValue) {
    config.initValue = false;
  }
  mounted(uiData, props, config);
  uiData.data;
  try {
    if (props.queryZeitbereich) {
      config.zeitbereich = props.queryZeitbereich;
    }
    await refreshData();
    if (!field && config.column) {
      field = config.column;
    }

    // mit dem Parameter kein Subformular - kann alles übersteuert werden!
    if (field) {
      // const subFormular = !field.meta.noSubFom;
      if (field.meta.keinVorfuellen) {
        useAutocomplete = true;
      }
    }
    if (Constants.isMobile && !useAutocomplete && !uiData.disabled) {
      showSelect = true;
    }
    // ist eine Combobox unsichtbar - aber auf zwingend - dann muss sie trotzem befüllt werden!
    if (
      !uiData.disabled ||
      (uiData.disabled && uiData.required) ||
      config.column?.meta.mobil
    ) {
      if (config.column && config.column.meta.Stt) {
        if (field.meta.noSubFom) {
          uiData.showSettings = false;
        } else {
          const stt = field.meta.Stt;
          const begr = globalsStt(Globals.Begriff, stt, "", true);
          if (begr) {
            sysAbfrage = begr.kennung;
            uiData.showSettings = true;
            anzahlCols.value = 11;
          }
        }
      }

      if (field && field.meta && field.meta.combo) {
        if (uiData.data) {
          if (uiData.data.aic !== undefined) {
            const element = field.meta.combo.find(
              (f: any) => f.aic === uiData.data.aic,
            );
            if (element) {
              uiData.selected = element;
              if (uiData.selected) {
                uiData.selected.description = uiData.selected?.bezeichnung;
              }
            }
          } else {
            const ix = field.meta.combo.indexOf(uiData.data);
            uiData.selected = uiData.data;
            autofill = false;
            /* wenn die Combobox über eine andere Abfrage geladen werden muss - autofill auf FALSE stellen! */
          }
        }
        for (let i = 0; i < field.meta.combo.length; i++) {
          const entry: EditComboboxItemData = field.meta.combo[i];
          if (typeof entry === "object") {
            rawlist.push({ aic: entry.aic, description: entry.bezeichnung });
            // uiData.items.push(entry);
            aicMode = true;
          } else {
            rawlist.push({ aic: entry, description: entry });
            aicMode = false;
          }
        }
        uiData.items = rawlist;
        // uiData.columns = [];
        // uiData.visibleColumns = [];
        console.log(
          "loaded list with " +
            uiData.items.length +
            " items for " +
            uiData.description,
        );
        uiData.disabled = uiData.items.length == 0;
        // bei nur Barcode - am Handy muss Combobox gefüllt werden aber nur über barcode ausgewählt werden
        if (config.column?.meta.mobil && config.column?.meta.readOnly) {
          uiData.disabled = true;
        }
        // data selber kann leer sein dann soll die Combobox laut definition vorgefüllt werden
        uiData.data = getInitValue();
        if (
          uiData.data &&
          (uiData.data.length > 0 || uiData.data.aic !== undefined)
        ) {
          const element = uiData.data;
          uiData.selected = element;
          selectedValueChanged(uiData.selected, true);
          if (props.initStichtag) {
            uiData.showStichtag = true;
            uiData.hintText = "ab: " + props.initStichtag;
          }
          if (props.initPassValue) {
            uiData.hintText = "Wert aus: " + props.initPassValue;
          }
        } else if (
          config.column?.meta.required &&
          !config.column?.meta.keinVorfuellen
        ) {
          const element = uiData.items[0];
          uiData.selected = element;
          selectedValueChanged(uiData.selected, true);
        }
        await updateList();
        if (barcodeButtonVisible.value) {
          anzahlCols.value = 10;
        } else if (
          uiData.showSettings &&
          (barcodeButtonVisible.value || useAutocomplete)
        ) {
          anzahlCols.value = 11;
        } else if (useAutocomplete || uiData.showSettings) {
          anzahlCols.value = 11;
        } else {
          anzahlCols.value = 12;
        }
        initialized = true;
      } else if (field && field.meta.filter) {
        const filter = field.meta.filter;
        const query = globalsAic(Globals.Begriff, filter).kennung;
        const SbRefresh = globalsBegriffCache(Globals.Begriff, query);
        const cache = SbRefresh ? false : true; // SbRefresh = Berechtigung refresh - daher KEIN Cachen!
        // query aus der Begriffstabelle laden - und dmait Inhalt für die ComboBox - wenn COMBO leer ist!
        if (query) {
          uiData.showLoading = true;
          const vecStamm: any[] = [];
          // description ergänzen, sonst geht die suche nicht
          if (
            uiData.data &&
            uiData.data.bezeichnung &&
            !uiData.data.description
          ) {
            uiData.data.description = uiData.data.bezeichnung;
          }

          if (!useAutocomplete || props.loadFavorite) {
            let suche = "";

            if (props.loadFavorite && uiData.data) {
              suche = uiData.data.description + "%";
            } else if (useAutocomplete) {
              if (props.loadFavorite && uiData.data) {
                suche = uiData.data.description + "%";
              }
            }
            AUApi.Current.getQuery(
              query,
              (data: any) => dataLoadedFromServer(data),
              0, // Stammsatz für die ABfrage muss in diesem fall LEER Sein
              config.zeitbereich, // Zeitbereich muss auch übergeben werden...
              0,
              cache, // cachen ein ausschalten nach Definition
              false,
              "1",
              0,
              vecStamm,
              suche,
              false,
              0,
              [],
              [],
              austritte,
            );
          } else {
            initialized = true;
            // bei autoComplete sollen nur die erforderlichen Daten geladen werdern
            uiData.data = getInitValue();
            if (uiData.data && uiData.data.length > 0) {
              const element = uiData.data;
              uiData.selected = element;

              if (props.initStichtag) {
                uiData.showStichtag = true;
                uiData.hintText = "ab: " + props.initStichtag;
              }
              if (uiData.data?.bezeichnung) {
                reloadList(uiData.data.bezeichnung);
              }
            }
          }
        } else {
          console.warn(
            "kann query für begriff " +
              filter +
              " im Feld '" +
              uiData.description +
              "' (aic: " +
              config.column?.aic +
              ") nicht finden!",
          );
        }
      } else {
        let name = "" + props.kennung;
        if (field) {
          name += " " + field.name;
        }
        if (barcodeButtonVisible.value) {
          anzahlCols.value = 10;
        } else if (uiData.showSettings && barcodeButtonVisible.value) {
          anzahlCols.value = 11;
        } else if (uiData.showSettings) {
          anzahlCols.value = 11;
        } else {
          anzahlCols.value = 12;
        }
        initialized = true;
      }
    } else if (uiData.data && uiData.data.length > 0) {
      const element = uiData.data;
      uiData.selected = element;
      if (uiData.selected) {
        uiData.selected.description = uiData.selected?.bezeichnung;
      }
      if (props.initStichtag) {
        uiData.showStichtag = true;
        uiData.hintText = "ab: " + props.initStichtag;
      }
      if (useAutocomplete) {
        uiData.items.push(element);
        initialized = true;
        aicMode = true;
      }
    } else {
      uiData.data = getInitValue();
      // uidata.data = Object wenn readOnly und daten aus DB... daher nicht auf Length prüfen!
      if (uiData.data && uiData.data.aic) {
        const element = uiData.data;
        uiData.selected = element;
        if (uiData.selected) {
          uiData.selected.description = uiData.selected?.bezeichnung;
        }
        if (props.initStichtag) {
          uiData.showStichtag = true;
          uiData.hintText = "ab: " + props.initStichtag;
        }
      }
    }
  } catch (err) {
    console.log(err);
  }
  // $emit("mountFinished", selected);
  uiData.showLoading = false;
});

// Wenn die Combobox deaktiviert ist, den aktuellen Wert trotzdem persistieren
watch(
  () => uiData.disabled,
  (disabled: any) => {
    if (disabled) {
      const val = uiData.selected ?? getInitValue();
      valueChanged(config, uiData, val, false);
    }
  },
);
function debounce<T extends (...args: any[]) => any>(fn: T, delay = 300) {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

async function findSearch(val: string) {
  if (!val) {
    uiData.showLoading = false;
    return;
  }
  if (val !== uiData.selected?.description) {
    //  uiData.items = [];
    searchActive.value = true;
    uiData.showLoading = true;
    await reloadList(val);
  }
}
async function reloadList(val: string) {
  // von DB Daten holen!
  return new Promise<void>((resolve, reject) => {
    try {
      const stammtyp = field.meta.Stt;
      const suche = val + "%";
      const vecStamm: any[] = [];
      const cache = false;
      let query;
      if (query) {
        query = query;
      } else {
        const filter = field.meta.filter;
        query = globalsAic(Globals.Begriff, filter).kennung;
      }
      AUApi.Current.getQuery(
        query,
        (data: any) => dataLoadedFromServer(data),
        0, // Stammsatz für die ABfrage muss in diesem fall LEER Sein
        config.zeitbereich, // Zeitbereich muss auch übergeben werden...
        0,
        cache, // cachen ein ausschalten nach Definition
        false,
        "1",
        0,
        vecStamm,
        suche,
        false,
        0,
        [],
        [],
        austritte,
      );
    } catch (e) {
      reject(e);
    }
  });
}
function filterFunction(
  item: any,
  queryText: string,
  itemText: string,
): boolean {
  queryText = queryText.toLowerCase();
  if (item.headerHtml) {
    return true;
  }
  if (
    (
      itemText &&
      itemText.toLowerCase &&
      itemText.toLowerCase() + ""
    ).startsWith(queryText)
  ) {
    return true;
  }
  if (item.rowData) {
    const x = item.rowData.find(
      (t: string) =>
        t && t.toLowerCase && (t.toLowerCase() + "").startsWith(queryText),
    );
    if (x) {
      return true;
    }
  }
  return false;
}

async function updateList(reloadList?: boolean) {
  uiData.items = await computeList();
  if (reloadList) {
    setCompKey.value += +1;
  }
}

async function computeList() {
  if (!favColumn) {
    favorite = false;

    return rawlist;
  }
  favorite = true;
  const sortedlist = rawlist.sort((a: any, b: any) => {
    let f1 = "0";
    if (a.isHeader) {
      return -1;
    }
    if (b.isHeader) {
      return 1;
    }
    if (a.row) {
      f1 = a.row[favColumn.name];
    }
    let f2 = "0";
    if (b.row) {
      f2 = b.row[favColumn.name];
    }

    if (!f1) {
      f1 = "";
    }
    if (!f2) {
      f2 = "";
    }

    f1 += "_" + a.description;
    f2 += "_" + b.description;
    if (f1.toLowerCase() === f2.toLowerCase()) {
      return 0;
    }
    if (f1 > f2) {
      return 1;
    } else {
      return -1;
    }
  });
  return sortedlist;
}
async function dataLoadedFromServer(data: any) {
  try {
    // uiData.showLoading = false;
    const header = data.data.header;
    const columns = data.data.columns;
    if (props.query) {
      uiData.description = "";
    }

    let headerHtml = "<span class='ddHeader'>";
    let visibleColumns: DataColumn[] = [];
    if (Constants.isMobile) {
      visibleColumns = columns.filter(
        (c: any) =>
          c.meta &&
          !c.meta.invisible &&
          c.meta.mobil &&
          c.kennung !== kennungFavoritCol &&
          c.meta.kz !== kennungBarcodeCol,
      );
      if (visibleColumns.length === 0 || !visibleColumns) {
        visibleColumns = columns.filter(
          (c: any) =>
            c.meta &&
            !c.meta.invisible &&
            !c.meta.mobil &&
            c.kennung !== kennungFavoritCol &&
            c.meta.kz !== kennungBarcodeCol,
        );
      }
    } else {
      visibleColumns = columns.filter(
        (c: any) =>
          c.meta &&
          !c.meta.invisible &&
          !c.meta.mobil &&
          c.kennung !== kennungFavoritCol &&
          c.meta.kz !== kennungBarcodeCol,
      );
    }
    favColumn = columns.find((c: any) => c.kennung === kennungFavoritCol);
    const barcodeColumn = columns.find(
      (c: any) => c.meta.kz === kennungBarcodeCol,
    );

    // barcode icon sichtbar machen wenn in da app && wenn berechtigt
    // achtung BARCODE geht nur in der APP - da der Capacitor erforderlich

    barcodeButtonVisible.value =
      barcodeColumn &&
      Capacitor.getPlatform() !== "web" &&
      checkBegriff("Web_Barcode");

    let basePercent: number = 100;
    if (favColumn) {
      basePercent = 80;
    }

    const combo = data.data.data;
    if (combo.length > 0) {
      // es wird grpüft ob es daten gibt. wenn leer dann kann die Spalte weggelassen werden und die ComboBox wird damit lesbarer!
      const hasRawData = (value: any, column: DataColumn): boolean => {
        if (value === null || value === undefined) {
          return false;
        }
        if (column.type === "vonBis") {
          return !!value?.von || !!value?.bis;
        }
        if (typeof value === "string") {
          return value.trim().length > 0;
        }
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        if (typeof value === "object") {
          const vals = Object.values(value);
          if (vals.length === 0) {
            return false;
          }
          return vals.some((v: any) => {
            if (v === null || v === undefined) {
              return false;
            }
            if (typeof v === "string") {
              return v.trim().length > 0;
            }
            return true;
          });
        }
        return true;
      };
      const nonEmptyColumns = visibleColumns.filter((column) =>
        combo.some((row: any) => hasRawData(row?.[column.name], column)),
      );
      if (nonEmptyColumns.length > 0) {
        visibleColumns = nonEmptyColumns;
      }
    }

    const headerItem: EditComboboxItemData = {
      aic: -1,
      description: "",
      row: visibleColumns.map((c) => c.title),
    };
    // const allVisibleColumns = visibleColumns.concat(favColumn);
    let allVisibleColumns = visibleColumns;
    if (favColumn) {
      allVisibleColumns = visibleColumns.concat(favColumn);
    }

    const visibleColsWithWidthCount =
      visibleColumns.filter((col) => col.meta.webWidth)?.length ?? 0;
    const visibleColumnsLength = visibleColumns.length;
    let percent: number | undefined;

    if (visibleColumnsLength !== visibleColsWithWidthCount) {
      percent = Math.round(
        basePercent / (visibleColumns.length - visibleColsWithWidthCount),
      );
    } else {
      percent = Math.round(basePercent / visibleColsWithWidthCount);
    }

    headerItem.isHeader = true;

    const textKennung = props.textKennung ?? "BEZEICHNUNG";
    // zuerst spalte raussuchen und name -> propertyname in data row...
    let bezCol = columns.find((c: any) => c.kennung === textKennung);
    if (!bezCol) {
      bezCol = columns.find((col: any) => col.meta.sortiert === 1);
      if (!bezCol) {
        bezCol = columns.find((c: any) => c.datatype === "Stringx");
      }
    }
    const columnBez = bezCol.name;

    if (combo.length > 0) {
      aicMode = true;
      const mapped: EditComboboxItemData[] = combo.map((row: any): any => {
        const rowData = [];
        for (let i = 0; i < visibleColumns.length; i++) {
          const column = visibleColumns[i];
          rowData.push(getDisplay(row, column));
        }
        let barcode = "";
        if (barcodeColumn) {
          barcode = getDisplay(row, barcodeColumn);
        }

        return <EditComboboxItemData>{
          // aic vom objekt
          aic: row.aic_Stamm,
          // bezeichnung aus spalte...
          description: row[columnBez],
          row,
          percent,
          rowData,
          barcode,
          columns,
        };
      });
      rawlist = mapped;
      uiData.items = rawlist;
      uiData.visibleColumns = visibleColumns;
      uiData.columns = columns;
      uiData.favColumn = favColumn;

      await updateList();
      if (visibleColumns.length > 1 || favColumn) {
        mapped.unshift(headerItem);
      }
      console.log(
        "loaded list async with " +
          rawlist.length +
          " items for " +
          uiData.description,
      );

      uiData.disabled =
        uiData.disabled || (uiData.items && uiData.items.length === 0);
      if (config.column?.meta?.mobil && config.column?.meta?.readOnly) {
        uiData.disabled = true;
      }
      // erst hier darf ich die Werte inialisieren, denn erst jetzt ist
      // list befüllt!
      if (!searchActive.value) {
        data = getInitValue();
        if (data && data.length > 0) {
          const element = data[0];
          uiData.selected = element;
          selectedValueChanged(uiData.selected, false);
        } else if (data) {
          const element = data;
          uiData.selected = element;
          if (uiData.selected) {
            uiData.selected.description = uiData.selected.bezeichnung;
            selectedValueChanged(uiData.selected, true);
          }
        } else if (props.selectedItem) {
          selectedValueChanged(props.selectedItem, false);
        }
      }
      if (uiData.selected) {
        uiData.errorText = "";
        uiData.isChanged = false;
      } else if (
        config.column?.meta.required &&
        !config.column?.meta.keinVorfuellen
      ) {
        const element = uiData.items[0];
        uiData.selected = element;
        selectedValueChanged(uiData.selected, false);
      }
    } else {
      uiData.disabled = true; // wenn es keine Daten zur Auswahl gibt kann man das feld auf uidata.disabled stellen..
      uiData.showSettings = false;
      uiData.selected = undefined;
      valueChanged(config, uiData, uiData.selected, false);
    }
    if (config.column?.meta?.Stt && !uiData.disabled && !field.meta.noSubFom) {
      const stt = field.meta.Stt;
      const begr = globalsStt(Globals.Begriff, stt, "", true); // holt system Abfrage
      if (begr) {
        sysAbfrage = begr.kennung;
        if (field.meta.noSubFom) {
          uiData.showSettings = false;
        } else {
          uiData.showSettings = true;
          anzahlCols.value = 11;
        }
      }
    }
    if (barcodeButtonVisible.value) {
      anzahlCols.value = 10;
    } else if (
      uiData.showSettings &&
      (barcodeButtonVisible.value || useAutocomplete)
    ) {
      anzahlCols.value = 11;
    } else if (uiData.showSettings) {
      // auch autocomplete kann breit sein..
      anzahlCols.value = 11;
    } else {
      anzahlCols.value = 12;
    }
  } catch (err) {
    console.log(err);
  }
  initialized = true;
  uiData.showLoading = false;

  searchActive.value = false;
  nextTick(() => {
    combobox.value?.focus?.();
  });
}

async function scanBarcodeLocal() {
  const data = await scanBarcode();

  if (data.cancelled) {
    return;
  }

  if (data.content) {
    let txt = data.content;

    // Clean and parse the scanned text
    if (txt.indexOf("\n") >= 0) {
      txt = txt.split("\n")[0];
    }

    let compareVal: number | string = parseInt(txt, 10);
    if (isNaN(compareVal)) {
      compareVal = txt;
    }

    const foundItem = rawlist.find((item) => {
      let itemBarcode: number | string = parseInt(item.barcode, 10);
      if (isNaN(itemBarcode)) {
        itemBarcode = item.barcode;
      }
      return itemBarcode === compareVal;
    });
    if (foundItem) {
      selectedValueChanged(foundItem, false);
    } else {
      showSnackbar({
        text: globalsBegriffMemo(
          Globals.Begriff,
          "WEB_Barcode_falsch",
          "Barcode falsch - bitte überprüfen Sie diesen!",
        ),
        color: "error",
      });
    }
  } else {
    console.log("scanBarcodeLocal: No content in scanned data.");
  }
}

function selectByAic(aic: number) {
  selectedValueChanged(aic);
}

function selectedValueChanged(data: any, ausInit?: boolean) {
  validate();
  const isMobile = Capacitor.getPlatform() !== "web";
  if (isMobile) {
    Keyboard.hide();
  }
  if (!uiData.items || uiData.items.length === 0) {
    return;
  }

  const comboVal = data; // .itemData;
  if (typeof comboVal === "number") {
    uiData.selected = uiData.items.find((x: any) => x.aic === comboVal);
  } else if (typeof comboVal === "string") {
    // String kann entweder Beschreibung oder AIC sein
    const parsed = parseInt(comboVal, 10);
    if (!isNaN(parsed)) {
      uiData.selected = uiData.items.find((x: any) => x.aic === parsed);
    }
    if (!uiData.selected) {
      uiData.selected = uiData.items.find(
        (x: any) => x.description === comboVal,
      );
    }
  } else if (comboVal && comboVal.aic) {
    uiData.selected = comboVal;
  } else {
    uiData.selected = undefined;
  }
  if (
    uiData.selected &&
    !uiData.selected?.description &&
    uiData.selected.bezeichnung
  ) {
    uiData.selected.description = uiData.selected.bezeichnung;
  }
  if (uiData.selected && !uiData.selected.bezeichnung) {
    uiData.selected.bezeichnung = uiData.selected.description;
  }
  // aic aus Barcode/Server ggf. als Zahl normalisieren
  if (
    uiData.selected &&
    uiData.selected.aic &&
    typeof uiData.selected.aic === "string"
  ) {
    const parsed = parseInt(uiData.selected.aic as any, 10);
    if (!isNaN(parsed)) {
      (uiData.selected as any).aic = parsed;
    }
  }
  const val = uiData.selected;
  if (
    val == null ||
    (val && val.aic && (props.fireOnText || typeof val.aic !== "string"))
  ) {
    let nurInitalisierung = false;
    //  wenn nur Barcode -d ann ist auf ReadOnly gesetzt -aber es muss trotzdem gespeichert werden!
    if ((uiData.readonly && !barcodeButtonVisible.value) || ausInit === true) {
      nurInitalisierung = true;
    }
    valueChanged(config, uiData, val, nurInitalisierung); // zum event triggern
  }
}

// function getDefault() {
//   if (uiData.items && uiData.items.length > 1 && uiData.items[0].isHeader) {
//     return uiData.items[1];
//   }
//   if (uiData.items && uiData.items.length > 0) {
//     return uiData.items[0];
//   }
//   return null;
// }

function validate() {
  if (uiData.disabled) {
    uiData.errorText = "";
    return true;
  } // disabled Controls sind IMMER valide ;)
  if (uiData.required) {
    if (uiData.selected) {
      uiData.errorText = "";
      return true;
    }
    uiData.errorText = config.requiredMessage;
    return false;
  }
  uiData.errorText = "";
  return true;
}

function loadStichtag() {
  loadStichtagfromConfig(config);
}

function getInitValue(): any {
  if (config.column?.meta) {
    // STMM: kommt alles aufsselbe raus :)
    if (
      config.column.meta.neuArt === "Limit" ||
      config.column.meta.neuArt === "Last"
    ) {
      // wiedder entfernt, da ich sonst bei bestehenden bewegungssätzen wenn leer - trotzdem vorfülle!
      // if (!config.initValue) {
      //   return rawlist.filter((c: any) => c.aic != -1);
      // }
      // darf ich nur bei NEU machen ??
      // const dataList = rawlist.filter((c: any) => c.aic != -1)
      // return dataList[0];
    }
  }
  return config.initValue;
}
function openSettings() {
  const siteName = config.column!.title;
  const navData = {
    query: sysAbfrage,
    aic: uiData.selected?.aic,
    showClose: false,
  };
  // openSubPage("EditStamm", siteName, navData);
  if (props.openFromDialog) {
    showDialog({
      title: siteName,
      showTitle: true,
      site: "EditStamm",
      data: {
        query: sysAbfrage,
        aic: uiData.selected?.aic,
        showClose: false,
      },
      fullscreen: true,
      onClose: () => {
        return true;
      },
    });
  } else {
    onShowSite({
      title: siteName,
      site: "EditStamm",
      data: {
        query: sysAbfrage,
        aic: uiData.selected?.aic,
        showClose: true,
      },
      callOnLeave: () => {
        return true;
      },
    });
  }
}

function changeFav(data: any) {
  uiData.showLoading = true;
  AUApi.Current.setFavorit(data.aic, data.val > 0, null)
    .then(() => {
      uiData.showLoading = false;
      config.emit("onReloadData");
    })
    .catch((ex: any) => {
      uiData.showLoading = false;
    })
    .finally(() => updateList(true));
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-row class="pa-0 ma-0" v-bind="props">
          <v-col :cols="anzahlCols" class="pa-0">
            <v-combobox
              :key="setCompKey"
              :clearable="true"
              v-if="!showSelect && !useAutocomplete"
              :label="uiData.description"
              :items="uiData.items"
              :disabled="uiData.disabled"
              ref="combobox"
              item-title="description"
              item-value="aic"
              :return-object="true"
              v-model="uiData.selected"
              @update:modelValue="selectedValueChanged"
              @update:menu="updateOverlayWidth"
              :loading="uiData.showLoading"
              :cacheItems="false"
              :no-data-text="
                globalsBezeichnung(
                  Globals.Begriff,
                  'Web_keineDaten_gefunden',
                  'keine Daten gefunden',
                )
              "
              :filter="filterFunction"
              :menu-props="{ origin: 'auto', minWidth: 'min-content' }"
              :hint="uiData.hintText"
              persistent-hint
              :error-messages="uiData.errorText"
              :append-icon="uiData.showStichtag ? 'mdi-history' : ''"
              @click:append="loadStichtag"
              :required="uiData.required"
              item-color="warning"
              variant="outlined"
              density="compact"
              color="warning"
              :autoselect="props.autoselect"
              focused
            >
              <template v-slot:item="{ props, internalItem }">
                <EditComboBoxItem
                  v-if="uiData.columns"
                  v-bind="props"
                  :columns="uiData.columns"
                  :fav-column="uiData.favColumn"
                  :visible-columns="uiData.visibleColumns"
                  :style="'width:' + menuwith"
                  :item="internalItem.raw"
                  :overlay-width="overlayWidth"
                  @changeFav="changeFav"
                />
                <v-list-item v-bind="props" v-if="!uiData.columns">
                </v-list-item>
              </template>
            </v-combobox>

            <v-select
              :key="setCompKey"
              :clearable="clearable"
              v-if="showSelect && !useAutocomplete"
              :label="uiData.description"
              :items="uiData.items"
              :disabled="uiData.disabled"
              ref="combobox"
              item-title="description"
              item-value="aic"
              :return-object="true"
              v-model="uiData.selected"
              @update:modelValue="selectedValueChanged"
              @update:menu="updateOverlayWidth"
              :loading="uiData.showLoading"
              :cacheItems="cacheItems"
              :no-data-text="
                globalsBezeichnung(
                  Globals.Begriff,
                  'Web_keineDaten_gefunden',
                  'keine Daten gefunden',
                )
              "
              :filter="filterFunction"
              :menu-props="{ origin: 'auto', minWidth: 'min-content' }"
              :hint="uiData.hintText"
              persistent-hint
              :error-messages="uiData.errorText"
              :append-icon="uiData.showStichtag ? 'mdi-history' : ''"
              @click:append="loadStichtag"
              :required="uiData.required"
              item-color="warning"
              variant="outlined"
              density="compact"
              color="warning"
              :autoselect="props.autoselect"
            >
              <template v-slot:item="{ props, internalItem }">
                <EditComboBoxItem
                  v-bind="props"
                  v-if="uiData.columns"
                  :columns="uiData.columns"
                  :fav-column="uiData.favColumn"
                  :visible-columns="uiData.visibleColumns"
                  :style="'width:' + menuwith"
                  :item="internalItem.raw"
                  @changeFav="changeFav"
                  :overlay-width="overlayWidth"
                />
                <v-list-item v-bind="props" v-if="!uiData.columns">
                </v-list-item>
              </template>
            </v-select>
            <v-autocomplete
              :key="setCompKey"
              v-if="useAutocomplete"
              v-model="uiData.selected"
              ref="combobox"
              :items="uiData.items"
              @update:modelValue="selectedValueChanged"
              :loading="uiData.showLoading"
              @update:search="findSearch"
              item-title="description"
              item-value="aic"
              :return-object="true"
              :label="uiData.description"
              placeholder="Start typing to search"
              prepend-inner-icon="mdi-database-search"
              :hint="uiData.hintText"
              persistent-hint
              :error-messages="uiData.errorText"
              :filter="filterFunction"
              :clearable="clearable"
              hide-no-data
              :append-icon="uiData.showStichtag ? 'mdi-history' : ''"
              @click:append="loadStichtag"
              :required="uiData.required"
              item-color="warning"
              variant="outlined"
              density="compact"
              color="warning"
              @update:menu="updateOverlayWidth"
              :autoselect="props.autoselect"
            >
              <template v-slot:item="{ props, internalItem }">
                <EditComboBoxItem
                  v-bind="props"
                  v-if="uiData.columns"
                  :columns="uiData.columns"
                  :fav-column="uiData.favColumn"
                  :visible-columns="uiData.visibleColumns"
                  :style="'width:' + menuwith"
                  :item="internalItem.raw"
                  @changeFav="changeFav"
                  :overlay-width="overlayWidth"
                />
                <v-list-item v-bind="props" v-if="!uiData.columns">
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="1" class="pa-0" v-if="barcodeButtonVisible">
            <v-btn
              density="comfortable"
              variant="text"
              size="small"
              class="mt-2"
              @click="scanBarcodeLocal"
              icon="mdi-qrcode-scan"
            >
            </v-btn>
          </v-col>
          <v-col cols="1" class="pa-0" v-if="uiData.showSettings">
            <v-btn
              density="comfortable"
              variant="flat"
              size="small"
              color="blue darken-4"
              style="cursor: hand"
              @click="openSettings"
              icon="mdi-open-in-new"
              class="ml-1 mt-2 px-2"
              :rounded="false"
              min-height="30px"
            >
            </v-btn>
          </v-col>
        </v-row>
        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>
  </div>
</template>
